import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const careersHeroBlockFields = `
  _id,
  _type,
  heading,
  subheading,
  introText,
  buttonLink {
    ${inlineCtaFields}
  },
  backgroundImage {
    ${imageFields}
  },
  mobileImage {
    ${imageFields}
  },
  desktopImage {
    ${imageFields}
  },
  variant,
  backgroundColor,
  decorativeShape
`

export const CAREERS_HERO_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-hero-block"][0]{
    ${careersHeroBlockFields}
  }
`)
